<template>
  <div>

    <!--        =-=-={{hideForPrint }}????{{printWidth}}-->
    <q-table

        ref="stable"

        :key="clock"
        :dark="themeCtx=='dark'"
        :hide-bottom="hideForPrint||!autoInit"
        :data="pivotData"
        :columns="columnsProcessed"
        :class="{printingSheme:hideForPrint,'my-sticky-virtscroll-table':!hideForPrint}"
        :expanded.sync="expanded"
        :row-key="COMdeep.rowby"
        xstyle="height:300px"
       :table-style="'height:' +(hideForPrint?'100%':optimalHeight+'px')"
        :flat="autoInit"
        :dense="autoInit"
        :rows-per-page-options="[0]"
        :virtual-scroll-item-size="48"
        :virtual-scroll-sticky-size-start="48">
      <template v-slot:header="props">
        <q-tr :props="props">
          <!--          <q-th auto-width/>-->
          <template v-for="col in props.cols">
            <q-th v-if="col.name=='_COM'" :key="col.name"
                  :props="props">
              <!--              <q-btn flat rounded @click="$emit('close-pivot',COMdeep)" v-show="!hideForPrint"><span-->
              <!--                  class="material-icons">-->
              <!--close-->
              <!--</span></q-btn>-->
              <q-btn outline style="padding-left: 8px;float: left;padding-right: 8px" @click="generateReport()"
                     v-show="!hideForPrint"><span class="material-icons">
print
</span></q-btn>
            </q-th>
            <q-th
                v-else
                :key="col.name"
                :props="props"

                v-html="col.label">

            </q-th>
          </template>
        </q-tr>
      </template>
      <template v-slot:body="props">

        <q-tr :props="props">
          <!--          <q-td fit-width>-->
          <!--            <el-select-->
          <!--                xstyle="width: 100px"-->
          <!--                v-model="props.row._COM.rowby"-->
          <!--                filterable-->
          <!--                fit-width-->
          <!--                placeholder="Select field for rows"-->
          <!--                clearable>-->
          <!--              <el-option-->
          <!--                  v-for="item in fieldsFilterBy('rows')"-->
          <!--                  :key="item.key"-->
          <!--                  :label="item.name"-->
          <!--                  :value="item.key"></el-option>-->
          <!--            </el-select>-->
          <!--            &lt;!&ndash;            <q-toggle v-model="props.expand" checked-icon="add" unchecked-icon="remove"/>&ndash;&gt;-->
          <!--          </q-td>-->
          <q-td
              v-for="col in props.cols"
              fit-widt
              :key="col.name"
              :props="props"
              :class="{expantedRow:props.expand&&props.row._COM.rowby,controlCell:col.name=='_COM'}"
          >
            <template v-if="col.name=='_COM'">
              <q-btn v-if="props.expand&&props.row._COM.rowby" flat rounded style="float: left"
                     @click="props.row._COM.rowby=null;props.expand=false" v-show="!hideForPrint"><span
                  class="material-icons">
close
</span></q-btn>
              <el-select
                  v-else
                  v-show="!hideForPrint"
                  xstyle="width: 100px"
                  v-model="props.row._COM.rowby"
                  filterable
                  fit-width
                  placeholder="Select field for rows"
                  clearable
                  @change="goDeeper(props)">
                <el-option
                    v-for="item in fieldsFilterBy('rows')"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"></el-option>
              </el-select>

            </template>
            <div v-else-if="props.expand&&hideForPrint&&props.row._COM.rowby&&col.value==props.key"
                 style="font-weight: bold;border-left: 2px solid"><span
                class="material-icons">
subdirectory_arrow_right
</span>
<!--              <small>{{ props.row._COM.rowby }}:</small>-->
              {{ props.key }}
            </div>
            <span v-else>
            {{ col.value }}
              </span>

            <!--          <QsTd-->
            <!--              :colProps="props"/>-->
          </q-td>
        </q-tr>
        <q-tr v-show="props.expand" :props="props">
          <q-td colspan="100%" style="padding: 0px">
            <div style="width: 100%;padding-left: 20px;border-left: 1px solid">
              <!--              -&#45;&#45;{{props.row._COM}}-->
              <PivotTable v-if="props.expand" :COM="props.row._COM" :fieldDefinitions="fieldDefinitions"
                          :printMode="hideForPrint"
                          :key="props.row._COM.rowby"
                          autoInit
                          @close-pivot="props.expand=false"></PivotTable>
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <div>
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="hee hee"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="landscape"
          :pdf-content-width="printWidth"

          xprogress="onProgress($event)"
          xhasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="pdfReady"
          ref="html2Pdf"
      >
        <section slot="pdf-content">
          <div ref="pdfContent" v-html="contentToPrint">
            hello
          </div>
          <!-- PDF Content Here -->
        </section>
      </vue-html2pdf>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import VueHtml2pdf from 'vue-html2pdf'
import * as api from "~/api/resource";
import SqTable from "../../Form/SqTable.vue";
import QsTd from "../../Form/QsTd.vue";

export default {
  name: 'PivotTable',
  components: {QsTd, SqTable, VueHtml2pdf},
  data() {
    return {
      contentToPrint: null,
      pivotCols: null,
      loaded: false,
      iCOM: {
        subConstrain: null
      },
      processLog: [],
      detailedDialog: false,
      optimalHeight: "100vh",
      vhhpx: 0,
      fileInfo: {},
      hotels: {},
      col_trip_w: "80px",
      clock: 0,
      detailedData: null,
      columns: [],
      dataLoaded: false,
      firstCol: null,
      notResolved: true,
      pivotData: [],
      heightWish:'tobottom',
      expanded: [],
      totalAggregation: "sum",
      enablePrint: false,
      printWidth: '100%'
    };
  },
  props: {
    printMode: {type: Boolean, default: false},
    COM: {},
    autoInit: {type: Boolean, default: false},
    // columnsForTable: {},
    // dataLoaded: {},
    getDetails: {},
    fieldDefinitions: {}

  },
  mounted() {
    if (this.autoInit !== false) this.renderPivot()
  },
  methods: {
    pdfReady(ev) {
      _log_('pdfReady', ev)
      this.enablePrint = false
    },
    generateReport() {

      this.enablePrint = true
      this.$nextTick(() => {
        // this.printWidth=this.$refs.stable.$el.getBoundingClientRect().width+'px'
        this.contentToPrint = this.$refs.stable.$el.innerHTML

        // this.$refs.pdfContent.$el.appendChild(this.$refs.stable.$el)
        this.$refs.html2Pdf.generatePdf()
        this.enablePrint = false
      })
    },
    goDeeper(colProps) {

      colProps.row._COM = {
        ...this.COM,
        rowby: colProps.row._COM.rowby,
        // _subConstrainField: this.COM.rowby,
        // _subConstrainValue: colProps.key
      }
      colProps.row._COM._subConstrains = colProps.row._COM._subConstrains || []
      colProps.row._COM._subConstrains.push(this.COM.rowby + '=' + colProps.key)

      // colProps.row._COM.rowby=colProps.row._COM.rowby

      colProps.expand = true
    },
    fieldsFilterBy(ctx) {
      return this.fieldDefinitions.pivots
      const vm = this;
      let o = null;
      const rowO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COMdeep.rowby
          }),
          colO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COMdeep.colby
          });
      if (ctx == "cols")
        o = this.fieldDefinitions.pivots
        //     .filter(
        //     e => !rowO || e.field != rowO.field
        // );
      if (ctx == "rows")
        o = this.fieldDefinitions.pivots.filter(
            e => !colO || e.field != colO.field
        );
      return o;
    },
    handleCellClick(scope) {
      //compatibility with s-table
      scope.col.property = scope.col.prop
      scope.column = scope.col
      this.$emit(
          'cell-clicked',
          scope
      )
    },
    pivotDecorator(data) {
      // _log_('pivotDecorator', data.value)
      return data.value && data.value != '0' && this.COMdeep.pivotrender ? 'clickme' : null
    },

    async renderPivot(excel) {
      this.loaded = false;
      this.dataLoaded = false;
      this.firstCol = JSON.parse(JSON.stringify(this.COMdeep.rowby));
      _log_(
          "sss...renderPivot.",
          this.fieldDefinitions.pivot,
          this.COMdeep,
          rowO
      );
      // pipeActions(['=>route/pivot','->renderPivot'],COMdeep);

      switch (this.pivotctx) {
        case "Transfers":
          this.COMdeep.from = "routes";
          break;
        case "Excursions":
          this.COMdeep.from = "trips";
          break;
        case "Bookings":
          this.COMdeep.from = "bookings";
          break;
        default:
          break;
      }

      // this.COMdeep.from = this.pivotctx == "Transfers" ? "routes" : "trips";
      const vm = this,
          rowO = this.findInArray(this.fieldDefinitions.pivots, {
            name: this.COMdeep.rowby
          });
      let colO = null;
      // this.COMdeep.colby_field = [];
      // this.COMdeep.colby.forEach((element) => {
      //   colO = vm.findInArray(vm.fieldDefinitions.pivots, {
      //     name: element,
      //   });
      //   if (colO) {
      //     vm.COMdeep.colby_field.push(colO.field);
      //     vm.COMdeep.colby_format = colO.format;
      //   }
      // });
      // this.COMdeep.value_field = this.pivotFields;
      // this.COMdeep.rowby_field = JSON.stringify(rowO);
      // this.COMdeep.rowby_format = rowO.format;

      if (excel) {
        api.ajax_download("transdrafts/pivot", {
          ...this.COMdeep,
          ...this.$route.query,
          pivotFields: JSON.stringify(this.pivotFields),
          download: 1
        });
        this.dataLoaded = true;
        this.loaded = true;
        // return;
      }
      let serverCom = {
        ...this.COMdeep,

        pivotFields: JSON.stringify(this.pivotFields)
      };
      // if (!this.autoInit) {
      //   serverCom = {...serverCom, ...this.$route.query}
      //
      // }
      serverCom = {...this.$route.query, ...serverCom}
      if (_.isArray(serverCom.colby)) serverCom.colby = serverCom.colby[0]
      const {data} = await api.fetchProcessor("transdrafts/pivot", serverCom),
          VMO = this;

      if (!data) return;
      this.pivotData = null;
      let rs = data.results,
          rc = null;
      let fd = _.find(this.fieldDefinitions.pivots, {
        name: VMO.COMdeep.rowby
      });

      // if (fd) rc = { field: fd.field.replace(".", "_"), name: fd.name };
      // else rc = VMO.COMdeep.rowby.replace(".", "_");

      if (VMO.columns.length > 0) VMO.columns.splice(0, VMO.columns.length);
      this.pivotCols = data["cols"];
      // VMO.columns.push(rc);
      // if (this.COMdeep.pivotrender) this.pivotCols = data["cols"];
      // else this.pivotCols = null;
      // {

      //   var sample = rs[0];
      //   const allFields = [
      //     ...this.fieldDefinitions.pivots,
      //     ...this.fieldDefinitions.datas,
      //   ].map((e) => {
      //     return {
      //       field: e.field.replace(".", "_"),
      //       name: e.name,
      //       aggregate: !!e.name.aggregator,
      //     };
      //   });
      //   for (const key in sample) {
      //     if (sample.hasOwnProperty(key) && key != this.COMdeep.rowby) {
      //       if (!VMO.COMdeep.pivotrender) {
      //         const colf = this.findInArray(allFields, { field: key });
      //         if (colf) VMO.columns.push(colf);
      //       } else if (fd && fd.field == key) VMO.columns.push(fd);
      //       else VMO.columns.push(key);
      //     }
      //   }
      // }
      // var excludeProp = VMO.COMdeep.rowby.replace(".", "_");
      if (VMO.COMdeep.pivotrender) {
        //add total column

        const cellDirective = vm.findInArray(vm.fieldDefinitions.datas, {
          name: this.$route.query.value,
        });
        let totalSums = {}
        //parse results
        rs.forEach(row => {
          let sum = 0;
          for (const key in row) {


            if (VMO.COMdeep.rowby != key && row.hasOwnProperty(key)) {
              if (!totalSums[key]) totalSums[key] = row[key]*1
              else totalSums[key] += row[key]*1
              sum += parseFloat(row[key]);
              if (cellDirective.format == 'money')
                row[key] = this.$theMoney(row[key]);
              else
                row[key] = row[key]; // parseFloat(row[key]).toFixed(2);

            }
          }
          if (!totalSums.TOTAL) totalSums.TOTAL = sum
          else totalSums.TOTAL += sum
          row.TOTAL = cellDirective.format == 'money' ? this.$theMoney(sum) : parseFloat(sum)
              .toFixed(2);
        });

        for (let totalSumK in totalSums) {
          let totalSum=totalSums[totalSumK]
          totalSums[totalSumK]= cellDirective.format == 'money' ? this.$theMoney(totalSum) : parseFloat(totalSum).toFixed(2);
        }
        totalSums[VMO.COMdeep.rowby]='GRAND TOTAL'
        rs.push(totalSums)
      }


      this.pivotData = rs.map(rec => {
        return {_COM: {rowby: null}, ...rec}
      })
      this.dataLoaded = true;
      // this.$nextTick(() => {
      //   _log_('colDirective', rs)
      //   this.$refs.pivotTable.wakeUp(rs);
      // });

      // this.$refs.pivotTable.appendTrackedData(rs);
      // this.$refs.pivotTable.wakeUp(rs);
      // this.pivotData = rs;
      // _log_(
      //   "sss....",
      //   VMO.columns,
      //   VMO.pivotData,
      //   VMO.COMdeep.rowby.replace(".", "_")
      // );

      this.loaded = true;
    },
    getSummaries(param) {
      this.loaded = false;
      const {columns, data} = param;
      const sums = [];
      const doaggr = this.totalAggregation;
      _log_(">>>>", doaggr);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Grand Total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              if (doaggr == "sum") return prev + curr;
              else return prev + (curr != 0 ? 1 : 0);
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });
      this.loaded = true;
      return sums;
    },
    dbg(msg) {
      _log_("VDBG:", msg);
    },
    calcHeight() {
      const vm = this;
      _log_(
          "hell height.999.",
          vm.heightWish,

          vm.topOffset
      );
      if (!vm.heightWish) {
        vm.optimalHeight = "";
        return;
      }
      this.$nextTick(function () {
        if (!vm.$refs.stable) return;
        const domEl = vm.$refs.stable.$el;
        var rect = domEl ? domEl.getBoundingClientRect() : null;
        vm.query = vm.rQuery;

        if (vm.isTouchDevice()) {
          this.$nextTick(function () {
            vm.optimalHeight = Math.round(window.innerHeight - rect.top - 5);
            if (vm.optimalHeight < 300) vm.optimalHeight = "100vh";
            // _log_("hell height.." + window.innerHeight);
            // vm.optimalHeight = window.innerHeight; //  - this.topOffset
            // vm.$refs.stable.doLayout();
          });

          return;
        } else {
          if (vm.heightWish == "tobottom") {
            vm.optimalHeight = Math.round(
                window.innerHeight - rect.top - vm.topOffset - 10
            );
            return;
          } else {
            if (vm.heightWish.indexOf("-") == 0) {
              vm.optimalHeight =
                  window.innerHeight - rect.top + parseInt(vm.heightWish);
            } else if (vm.heightWish.indexOf("%") > 0) {
              vm.optimalHeight =
                  (window.innerHeight * parseInt(vm.heightWish)) / 100;
            } else vm.optimalHeight = parseInt(vm.heightWish);
          }
          vm.optimalHeight = vm.optimalHeight - vm.topOffset;
        }
        _log_("hell height.FINALL." + vm.optimalHeight);
      });
    },
  },
  computed: {
    hideForPrint() {
      return this.printMode || this.enablePrint
    },
    COMdeep() {
      let coms = {...this.COM}

      _log_('COMdeep', coms)
      return coms
    },
    columnsProcessed() {
      // return
      if (this.pivotData?.[0]) {
        let idx = 0
        const sampleKeys = Object.keys(this.pivotData?.[0])
        return [
          // {name: '_COM', field: '_COM', prop: '_COM'},
          ...sampleKeys.map(col_prop => {
            let col = {}
            col.name = col_prop
            col.field = col_prop
            col.label = col_prop.replaceAll('_', ' ')
            // if (col.sortable === undefined) col.sortable = true
            return col
          })
        ]

      }
    },
    columnsForTable() {
      let idx = 0,
          incols = [];
      for (const key in this.restpivotFields) {
        if (Object.hasOwnProperty.call(this.restpivotFields, key)) {
          const fld = this.restpivotFields[key];
          incols.push({
            width: "150px",
            prop: key,
            label: fld.name ? fld.name : fld,
            formatter(val, cols, row) {
              return row[cols.prop];
            }
          });
        }
      }

      return [
        {
          fixed: "left",
          width: "150px",
          prop: this.firstDisplayField.key,
          label: this.firstDisplayField.name,
          formatter(val, cols, row) {
            // _log_("yello", val, cols, row);
            return row[cols.prop];
          }
        },
        ...incols,
        {label: "TOTAL", prop: "TOTAL", fixed: 'right'}
      ];
    },
    firstDisplayField() {
      let element = null,
          keyFount;

      for (const key in this.pivotFields) {
        if (this.pivotFields.hasOwnProperty(key)) {
          element = this.pivotFields[key];
          if (element.name == this.firstCol) {
            keyFount = key;
            break;
          }
        }
      }
      return element ? {...element, key: keyFount} : null;
    },
    restpivotFields() {
      let o = {};
      if (this.pivotCols) return this.pivotCols;

      for (const key in this.pivotFields) {
        if (this.pivotFields.hasOwnProperty(key)) {
          let element = this.pivotFields[key];
          if (element.name != this.firstCol) o[key] = element;
        }
      }
      return o;
    },
    pivotFields() {
      const vm = this;
      let r = {};
      [...this.fieldDefinitions.pivots,
        ...this.fieldDefinitions.datas].forEach(
          element => {
            r[element.key] = element;
          }
      );
      return r;

    },

  }
}
</script>
<style>
.q-table tbody td.expantedRow {
  border-top: 1px double;

  font-weight: bold;
}

.q-table tbody td.expantedRow.controlCell {
  border-left: 1px double;
}

.el-autocomplete-suggestion li {
  padding: 2px !important;
}

.printingSheme {
  background: white;
  color: black;
}
</style>